import { BrandLogo } from '@/components/ui/BrandLogo';
import { Button } from '@/components/ui/Button';
import { EmptyState, ErrorState, LoadingState } from '@/components/ui/StateMessage';

import { useLogout } from '../../hooks/useAuthActions';
import styles from './Guards.module.css';

/** Shown while the signed-in user's profile loads, before any layout renders. */
export function FullPageLoading() {
  return (
    <div className={styles.fullPage}>
      <LoadingState label="Opening Club29…" />
    </div>
  );
}

export function FullPageError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  return (
    <div className={styles.fullPage}>
      <ErrorState error={error} title="Club29 could not start" onRetry={onRetry} />
    </div>
  );
}

/**
 * A member login signed in on the website. Members get the mobile app (it uses the API's `/me`
 * endpoints); the website is only for gym staff, so all they can do here is sign out.
 */
export function MemberAppNotice() {
  const logout = useLogout();
  return (
    <div className={styles.fullPage}>
      <div className={styles.notice}>
        <BrandLogo size="md" />
        <EmptyState
          icon="phone"
          title="This website is for Club29 staff"
          description="Members see their membership in the Club29 app on their phone. Sign out here and use the app instead."
          action={
            <Button
              icon="logout"
              isLoading={logout.isPending}
              onClick={() => {
                logout.mutate();
              }}
            >
              Log out
            </Button>
          }
        />
      </div>
    </div>
  );
}
